export enum AiGenerationTypes {
    jsonSchema = 'json_schema',
    documentation = 'documentation',
    code = 'code',
    description = 'description_builder',
    generalSchema = 'general_schema',
    schemaToJson = 'schema_to_json',
    responseMapping = 'response_mapping',
    sqlQuery = 'sql_query',
}